export default function moderationModal(entryIds = []) {
  return {
    entryIds: entryIds,

    init() {
      Alpine.store('EntryModeration', {
        ids: entryIds,
        currentId: null,

        setCurrentId: (id) => {
          this.currentId = id;
        },

        isLastId: () => this.currentId === this.entryIds.at(-1),
        isFirstId: () => this.currentId === this.entryIds[0],

        nextId: (id = this.currentId) => {
          const index = this.entryIds.indexOf(id);
          if (this.entryIds.length > index + 1) {
            return this.entryIds.at(index + 1);
          }
        },

        previousId: (id = this.currentId) => {
          const index = this.entryIds.indexOf(id);
          if (index > 0) {
            return this.entryIds.at(index - 1);
          }
        },
      });
    },
  };
}
